import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import { OFFLINE_STATUS_TOOLBAR_LABELS } from '../constants/offlineStatusToolbarLabels';

export default function OfflineStatusToolbar({
  pendingCount,
  hasFailedPunch,
  showWifiToolbar,
  showQueueToolbar,
  onToggleOfflineSnackbar,
  onOpenOfflinePunchDrawer,
}) {
  const theme = useTheme();
  const hasPendingPunches = pendingCount >= 1;
  const defaultIconColor = theme.palette.text.secondary;
  const pendingPunchesIconColor = theme.palette.primary.main;
  const punchIconColor = hasFailedPunch
    ? theme.palette.error.main
    : hasPendingPunches
      ? pendingPunchesIconColor
      : defaultIconColor;

  return (
    <Box
      id="webclock-offline-status-toolbar"
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        pb: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {showWifiToolbar && (
          <IconButton
            id="sc-offline_status_wifi_button"
            aria-label={OFFLINE_STATUS_TOOLBAR_LABELS.WIFI_ARIA_LABEL}
            onClick={onToggleOfflineSnackbar}
            size="small"
          >
            <WifiOffIcon sx={{ color: defaultIconColor }} />
          </IconButton>
        )}
        {showQueueToolbar && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              id="sc-offline_status_queue_button"
              aria-label={OFFLINE_STATUS_TOOLBAR_LABELS.QUEUE_ARIA_LABEL}
              onClick={onOpenOfflinePunchDrawer}
              size="small"
            >
              <PunchClockIcon sx={{ color: punchIconColor }} />
            </IconButton>
            {hasPendingPunches && (
              <Typography
                id="sc-offline_status_queue_count"
                component="span"
                sx={{ color: pendingPunchesIconColor, pr: 0.5 }}
              >
                ({pendingCount})
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

OfflineStatusToolbar.propTypes = {
  pendingCount: PropTypes.number.isRequired,
  hasFailedPunch: PropTypes.bool.isRequired,
  showWifiToolbar: PropTypes.bool.isRequired,
  showQueueToolbar: PropTypes.bool.isRequired,
  onToggleOfflineSnackbar: PropTypes.func.isRequired,
  onOpenOfflinePunchDrawer: PropTypes.func.isRequired,
};
